<template>
  <div class="stage">
    <h4 class="mb-5">Thank You</h4>
    <div class="card">
      <div class="card-body">
        <icon
          :data="checkCircle"
          width="100"
          height="100"
          dir="up"
          color="#17bd2c"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import checkCircle from "@fa/solid/check-circle.svg";
export default {
  name: "ThankYou",
  data: () => ({
    checkCircle
  }),
  computed: {
    ...mapGetters(["getApplicationUuid"])
  },
  methods: {
    ...mapActions(["startTrace"])
  },
  mounted() {
    this.startTrace(this.getApplicationUuid);
  }
};
</script>
